$(function () {
  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);

    js.onload = function () {
      window.fbAsyncInit = function () {
        FB.init({
          appId: fbAppId,
          autoLogAppEvents: true,
          xfbml: true,
          cookie: false,
          version: 'v21.0'
        });

        $('#FacebookLoginButton').click(function (e) {
          FB.login(function (response) {
            if (response.status === 'connected') {
              // Logged into your app and Facebook.
              FB.api('/me?fields=id,email', function (response) {
                $("#FacebookEmail").val(response.email);
                $("#FacebookUserId").val(response.id);
                $('#FacebookLoginForm').submit();
              });
            }
          }, { scope: 'email' });
        });
      };
    };
  }(document, 'script', 'facebook-jssdk'));
});
